var _path, _path2, _path3, _path4, _path5, _path6, _rect, _path7, _polygon, _circle, _circle2, _path8, _circle3, _path9, _path10, _path11, _path12, _circle4, _path13, _path14, _path15, _path16, _path17, _path18, _polygon2, _path19, _polygon3, _path20, _rect2, _rect3, _rect4, _circle5, _circle6, _circle7, _rect5, _rect6, _path21, _path22, _path23, _path24, _circle8, _path25, _path26, _path27, _path28, _rect7, _polygon4, _polygon5, _rect8, _rect9, _rect10, _circle9, _circle10, _circle11, _rect11, _rect12, _path29, _path30, _path31, _path32, _polygon6, _circle12, _circle13, _path33, _circle14, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVirtualchat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 1157.30725,
    height: 499.03377,
    viewBox: "0 0 1157.30725 499.03377",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M434.02278,633.42881l25.9296-8.22505a87.77015,87.77015,0,0,0-.62466-42.22558c-10.41724,23.16251-40.97985,28.83748-58.39353,47.32491a52.79388,52.79388,0,0,0-13.50513,43.722L381.97373,692.531a88.46589,88.46589,0,0,0,64.38476-36.62448A85.45322,85.45322,0,0,0,456.37132,636.951C445.31335,635.84408,434.02278,633.42881,434.02278,633.42881Z",
    transform: "translate(-21.34638 -200.48312)",
    fill: "#f2f2f2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M406.31536,599.2087l19.53987-18.92588a87.77,87.77,0,0,0-19.39089-37.5151c1.00616,25.37732-23.81774,44.087-31.15868,68.40021a52.79393,52.79393,0,0,0,7.41151,45.15609l3.37052,18.99652A88.466,88.466,0,0,0,427.381,613.82569a85.45335,85.45335,0,0,0,.5081-21.43152C417.49807,596.33508,406.31536,599.2087,406.31536,599.2087Z",
    transform: "translate(-21.34638 -200.48312)",
    fill: "#f2f2f2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M783.95873,615.19273l7.98486-26.00456a87.77011,87.77011,0,0,0-35.0839-23.50552c13.12443,21.74328.40683,50.10771,5.70643,74.9459a52.79388,52.79388,0,0,0,28.27718,35.97783l12.11706,15.0135a88.466,88.466,0,0,0,6.50218-73.78667,85.45313,85.45313,0,0,0-9.89442-19.01759C792.36762,607.28064,783.95873,615.19273,783.95873,615.19273Z",
    transform: "translate(-21.34638 -200.48312)",
    fill: "#f2f2f2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M740.05341,618.5153,735.60266,591.679a87.77018,87.77018,0,0,0-41.8846-5.39168c21.444,13.60791,22.71122,44.66709,38.53194,64.53481a52.7939,52.7939,0,0,0,41.3547,19.5906l17.541,8.03374a88.46592,88.46592,0,0,0-27.08772-68.942,85.4532,85.4532,0,0,0-17.33741-12.60883C744.05108,607.68344,740.05341,618.5153,740.05341,618.5153Z",
    transform: "translate(-21.34638 -200.48312)",
    fill: "#f2f2f2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M627.297,436.65058a8.03684,8.03684,0,0,1,1.38129.413l17.46111-47.37293,1.6317-48.62666a12.09185,12.09185,0,0,1,24.1085-.87887l0,0a95.39639,95.39639,0,0,1-1.45512,29.53985l-6.66134,32.05791-30.413,45.21728a8.01612,8.01612,0,1,1-6.0531-10.34958Z",
    transform: "translate(-21.34638 -200.48312)",
    fill: "#ffb8b8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M666.37009,390.11237l-21.26067-3.14416-3.61157-45.17647a19.01659,19.01659,0,1,1,37.30149,7.42436Z",
    transform: "translate(-21.34638 -200.48312)",
    fill: "#2f2e41"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 638.04067,
    y: 390.66747,
    width: 44.90328,
    height: 44.90328,
    transform: "translate(1299.63825 625.75511) rotate(-180)",
    fill: "#ffb8b8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M655.68125,317.69964l9.03811-11.61772,12.89268-.559,1.28678,10.92664,6.38829,2.94576a171.329,171.329,0,0,1,2.88591,74.22664l0,0v0a6.60917,6.60917,0,0,0-1.88,6.42l.41415,1.65108-.03832.06047a9.67164,9.67164,0,0,0-1.284,7.22047h0l11.67866,20.75192c-24.8006,10.10806-42.98158-8.74208-59.82466-33.44548l-10.424-36.083Z",
    transform: "translate(-21.34638 -200.48312)",
    fill: "#6c63ff"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "607.163 184.018 604.729 159.675 637.044 111.838 638.373 112.735 606.383 160.092 608.759 183.859 607.163 184.018",
    fill: "#2f2e41"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 607.96127,
    cy: 183.93855,
    r: 2.40553,
    fill: "#2f2e41"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 644.72742,
    cy: 84.9688,
    r: 23.83777,
    fill: "#ffb8b8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M669.67106,256.4404l2.89212.76981.9822.26143,11.00626,2.92959c9.75543,2.59665,15.2956,13.59859,12.37434,24.57354,5.39382,9.35076.71988,18.02256-7.77417,26.4367a119.65576,119.65576,0,0,0-32.82018.03946l.1898-6.30089-4.81881,7.082q-4.12623.798-8.27853,1.94356c6.2918-12.39069,10.93041-25.18875,11.72056-35.87915l-5.04-1.34153,1.4681-5.51557-3.179,5.06017-9.1372-2.43209,0,0A24.857,24.857,0,0,1,669.67106,256.4404Z",
    transform: "translate(-21.34638 -200.48312)",
    fill: "#2f2e41"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 668.64023,
    cy: 59.46519,
    r: 11.22582,
    fill: "#2f2e41"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M650.29229,442.87116a8.038,8.038,0,0,1,1.43533.13537l7.87764-49.87011-7.892-48.00969a12.09184,12.09184,0,0,1,23.47313-5.56813v0a95.39624,95.39624,0,0,1,4.33927,29.25562l-.27525,32.74152L658.24926,451.84a8.01612,8.01612,0,1,1-7.957-8.96887Z",
    transform: "translate(-21.34638 -200.48312)",
    fill: "#ffb8b8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M679.52906,389.6009l-21.46541,1.06657-12.36088-43.60235a19.01659,19.01659,0,1,1,38.03318,0Z",
    transform: "translate(-21.34638 -200.48312)",
    fill: "#2f2e41"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M569.59011,399.029a8.66833,8.66833,0,0,0-12.90239-3.19426l-25.32227-17.54122L531,394.29689l24.10248,14.204a8.71533,8.71533,0,0,0,14.48761-9.47189Z",
    transform: "translate(-21.34638 -200.48312)",
    fill: "#ffb6b6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M545.49515,404.28144l-48.71236-27.11908-.01337-.23715c-.02583-.4535-2.5587-45.49286-1.56416-55.105a25.58552,25.58552,0,0,1,7.12513-15.45407l.10648-.09753.144-.01369a12.98383,12.98383,0,0,1,13.538,8.96833,91.968,91.968,0,0,1,3.09279,42.075l-1.28539,8.00483,32.44408,24.65809Z",
    transform: "translate(-21.34638 -200.48312)",
    fill: "#6c63ff"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 486.76832,
    cy: 69.22996,
    r: 21.12584,
    fill: "#ffb6b6"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M508.81361,289.92172c-4.9392,2.36991-11.01868,1.5672-15.73436-1.22107s-8.186-7.33559-10.61119-12.24789c-1.77615-3.59766-3.06658-7.7177-2.03794-11.59581s5.1317-7.12756,8.976-5.97888c-2.6337-2.12069-2.32668-6.494-.19852-9.12167s5.48583-3.89117,8.73033-4.84348c4.70867-1.38207,9.65641-2.35758,14.51253-1.65065s9.63727,3.33605,11.92235,7.67888a7.40263,7.40263,0,0,0,8.31715-3.57189,6.70663,6.70663,0,0,1-2.3056,7.82435l6.57685-3.56825c1.67654,2.324.15309,5.86851-2.39223,7.185s-5.622.96535-8.39992.26193-6.39667.85306-9.26176.90954-5.96443,1.55593-6.78472,4.30165c-.42963,1.43812-.17921,2.98247-.306,4.478s-.84332,3.15476-2.29279,3.54437c-.91578.24615-1.91768-.08-2.82571.19335a3.0317,3.0317,0,0,0-1.911,2.71444,8.901,8.901,0,0,0,.631,3.44479c1.43351,4.4192,3.72905,6.25231,5.16256,10.6715",
    transform: "translate(-21.34638 -200.48312)",
    fill: "#2f2e41"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M478.40636,429.51888l-.01192-.00133-.167-.02848-.04832-.16239c-.60737-2.04293-1.38025-4.134-2.12771-6.15646a74.23272,74.23272,0,0,1-2.78326-8.57952,65.71116,65.71116,0,0,1-1.23011-8.44562c-.20851-2.061-.42414-4.19233-.79079-6.29036a3.85294,3.85294,0,0,1,1.05081-2.66693,3.53162,3.53162,0,0,0,.96609-2.245,5.3414,5.3414,0,0,0-1.68886-2.28438,5.50434,5.50434,0,0,1-1.85271-2.62753,261.76111,261.76111,0,0,1-2.35852-37.70833c.175-17.44683.9635-29.33884,2.34342-35.34622,3.71054-16.15276,20.85349-19.10054,23.53679-19.46446a5.92519,5.92519,0,0,1,8.01355-3.30477l12.18033,5.57584a19.8297,19.8297,0,0,1,10.54312,11.77489l1.80945,5.5162.90632,37.03-5.02266,26.0764L529.5,418.76772C477.19652,447.48362,478.5748,429.51888,478.40636,429.51888Z",
    transform: "translate(-21.34638 -200.48312)",
    fill: "#6c63ff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M547.78076,413.91219a8.66832,8.66832,0,0,0-12.18682-5.30626l-22.03347-21.52762-3.0357,15.71711,21.38875,18.03343a8.71533,8.71533,0,0,0,15.86719-6.91663Z",
    transform: "translate(-21.34638 -200.48312)",
    fill: "#ffb6b6"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M523.14679,415.06269l-43.49321-34.88092.02646-.236c.05035-.45145,5.08257-45.28041,7.67-54.591a25.58559,25.58559,0,0,1,9.6084-14.04545l.12128-.07835.14427.01057a12.98387,12.98387,0,0,1,11.84822,11.10534,91.968,91.968,0,0,1-3.98462,41.99992L502.4821,372.024,530.3474,401.759Z",
    transform: "translate(-21.34638 -200.48312)",
    fill: "#6c63ff"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M327.07815,557.015a10.05575,10.05575,0,0,0-14.96749-3.70552l-29.37526-20.3488-.424,18.56486L310.27166,568.003a10.11027,10.11027,0,0,0,16.80644-10.98792Z",
    transform: "translate(-21.34638 -200.48312)",
    fill: "#ffb6b6"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M299.12665,563.10819l-56.50906-31.45965-.01551-.2751c-.03-.52609-2.96823-52.77426-1.81452-63.92488a29.68071,29.68071,0,0,1,8.26556-17.92759l.12352-.11314.16706-.01588a15.062,15.062,0,0,1,15.70485,10.40376,106.688,106.688,0,0,1,3.5878,48.80935l-1.49112,9.286,37.63695,28.60476Z",
    transform: "translate(-21.34638 -200.48312)",
    fill: "#6c63ff"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "363.145 483.213 374.015 478.544 361.18 434.396 345.137 441.287 363.145 483.213",
    fill: "#ffb6b6"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M376.8279,681.98316l3.53409-1.518,11.388-11.53711,9.80478,2.43437.001-.00043a17.1509,17.1509,0,0,1,22.52577,8.99022l.21993.51207-40.48508,17.389Z",
    transform: "translate(-21.34638 -200.48312)",
    fill: "#2f2e41"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "314.246 484.351 326.076 484.35 331.704 438.72 314.244 438.72 314.246 484.351",
    fill: "#ffb6b6"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M329.22618,680.23573l3.8463-.00016,15.01657-6.10689,8.04842,6.106h.00109a17.15089,17.15089,0,0,1,17.15,17.14971v.55731l-44.06154.00163Z",
    transform: "translate(-21.34638 -200.48312)",
    fill: "#2f2e41"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 237.04317,
    y: 435.63643,
    width: 21.04715,
    height: 34.87817,
    fill: "#cacaca"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 299.88245,
    y: 643.1814,
    width: 4.811,
    height: 61.04492,
    transform: "translate(-446.26763 345.07364) rotate(-55.84051)",
    fill: "#cacaca"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 205.01582,
    y: 671.29839,
    width: 61.04492,
    height: 4.81097,
    transform: "translate(-358.99599 48.00218) rotate(-34.15969)",
    fill: "#cacaca"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 306.19808,
    cy: 490.35915,
    r: 6.61481,
    fill: "#cacaca"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 247.26604,
    cy: 490.35915,
    r: 6.61481,
    fill: "#cacaca"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 188.93533,
    cy: 490.35915,
    r: 6.61481,
    fill: "#cacaca"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 244.86066,
    y: 456.08235,
    width: 4.81078,
    height: 34.27679,
    fill: "#cacaca"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 243.05663,
    y: 404.96785,
    width: 9.0202,
    height: 46.30377,
    fill: "#cacaca"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M223.05515,612.66709V601.84281A7.52531,7.52531,0,0,1,230.572,594.326h70.29029a7.52535,7.52535,0,0,1,7.51684,7.51684v10.82428a7.52535,7.52535,0,0,1-7.51684,7.51685H230.572A7.52532,7.52532,0,0,1,223.05515,612.66709Z",
    transform: "translate(-21.34638 -200.48312)",
    fill: "#3f3d56"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M532.82486,699.51688H22.53086a1.19069,1.19069,0,0,1,0-2.38134h510.294a1.19068,1.19068,0,0,1,0,2.38134Z",
    transform: "translate(-21.34638 -200.48312)",
    fill: "#cacaca"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M213.5,540.76772l51,1,1.851,14.527s89.149-4.527,97,14c17.67886,41.71879,33,90,33,90l-22,7-43-72s-119.851,35.473-110.851-24.527Z",
    transform: "translate(-21.34638 -200.48312)",
    fill: "#2f2e41"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M367.77506,583.17344c-5.23261,45.0069-16.424,87.12128-16.424,87.12128l-21-3,4.783-84.8722",
    transform: "translate(-21.34638 -200.48312)",
    fill: "#2f2e41"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 234.41685,
    cy: 206.51826,
    r: 24.50716,
    fill: "#ffb6b6"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M256.574,430.44453c-5.72974,2.74923-12.78228,1.818-18.25273-1.41652s-9.49623-8.50969-12.30958-14.20823c-2.06043-4.17348-3.55741-8.953-2.36412-13.45179s5.95306-8.26837,10.41262-6.93583c-3.05523-2.46012-2.69908-7.53342-.23029-10.58165s6.36388-4.514,10.12768-5.61871c5.46232-1.60328,11.202-2.73492,16.83534-1.91485s11.17977,3.87,13.83059,8.90793a8.58746,8.58746,0,0,0,9.64836-4.14358,7.78008,7.78008,0,0,1-2.67462,9.07668l7.62951-4.13937c1.94488,2.696.1776,6.8078-2.77512,8.335s-6.52179,1.11986-9.74438.30384.5795,5.98961-2.74415,6.05513-6.91908,1.805-7.87066,4.99016c-.4984,1.66829-.2079,3.45982-.355,5.19475s-.9783,3.6597-2.65977,4.11167c-1.06235.28555-2.22461-.09276-3.278.2243a3.51693,3.51693,0,0,0-2.21686,3.14891,10.32551,10.32551,0,0,0,.732,3.99614c1.66295,5.12651-3.6741,2.253-2.01114,7.37954",
    transform: "translate(-21.34638 -200.48312)",
    fill: "#2f2e41"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M221.2999,592.385l-.01382-.00154-.19378-.03305-.056-.18838c-.70458-2.3699-1.60117-4.7957-2.46827-7.14183a86.11847,86.11847,0,0,1-3.22874-9.95272,76.22922,76.22922,0,0,1-1.427-9.7974c-.24188-2.3909-.492-4.86333-.91735-7.29716-.18885-1.08057.52685-2.104,1.219-3.09378.64174-.91752,1.248-1.78438,1.12072-2.6043-.13009-.83846-1.05995-1.75937-1.95917-2.65-.98568-.97619-2.005-1.98573-2.14925-3.04808a303.65548,303.65548,0,0,1-2.736-43.74377c.203-20.23929,1.11771-34.0347,2.71849-41.00359,4.30444-18.73811,24.19121-22.1577,27.304-22.57986a6.87358,6.87358,0,0,1,9.29617-3.83372l14.12986,6.46829a23.00355,23.00355,0,0,1,12.23061,13.65952l2.09906,6.39911,1.05139,42.95689-5.82658,30.25008,11.38443,17.07665C222.20264,585.53844,221.49531,592.385,221.2999,592.385Z",
    transform: "translate(-21.34638 -200.48312)",
    fill: "#6c63ff"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M926.46371,560.11661a8.03722,8.03722,0,0,1,1.3813.41295l17.46111-47.37293,1.6317-48.62666a12.09184,12.09184,0,0,1,24.10849-.87887l0,0a95.39579,95.39579,0,0,1-1.45512,29.53985l-6.66134,32.05791-30.413,45.21728a8.01612,8.01612,0,1,1-6.05311-10.34958Z",
    transform: "translate(-21.34638 -200.48312)",
    fill: "#ffb8b8"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M965.53678,513.5784l-21.26066-3.14416-3.61158-45.17647a19.01659,19.01659,0,1,1,37.3015,7.42436Z",
    transform: "translate(-21.34638 -200.48312)",
    fill: "#2f2e41"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 937.20737,
    y: 514.1335,
    width: 44.90328,
    height: 44.90328,
    transform: "translate(1897.97164 872.68717) rotate(-180)",
    fill: "#ffb8b8"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "809.373 445.894 792.224 440.124 782.674 486.804 794.294 490.713 809.373 445.894",
    fill: "#ffb6b6"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "839.786 437.013 822.178 441.177 838.737 485.853 850.668 483.031 839.786 437.013",
    fill: "#ffb6b6"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 899.21693,
    y: 435.63643,
    width: 21.04715,
    height: 34.87817,
    fill: "#cacaca"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 867.18959,
    y: 671.29836,
    width: 61.04492,
    height: 4.811,
    transform: "translate(-244.75478 419.80969) rotate(-34.15949)",
    fill: "#cacaca"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 962.05623,
    y: 643.18142,
    width: 4.81097,
    height: 61.04492,
    transform: "translate(-155.90491 893.00383) rotate(-55.84031)",
    fill: "#cacaca"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 851.10917,
    cy: 490.35915,
    r: 6.61481,
    fill: "#cacaca"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 910.04121,
    cy: 490.35915,
    r: 6.61481,
    fill: "#cacaca"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 968.37191,
    cy: 490.35915,
    r: 6.61481,
    fill: "#cacaca"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 907.63581,
    y: 456.08235,
    width: 4.81078,
    height: 34.27679,
    fill: "#cacaca"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 905.23042,
    y: 404.96785,
    width: 9.0202,
    height: 46.30377,
    fill: "#cacaca"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M969.428,620.18394H899.13772a7.52535,7.52535,0,0,1-7.51684-7.51685V601.84281a7.52535,7.52535,0,0,1,7.51684-7.51684H969.428a7.52531,7.52531,0,0,1,7.51684,7.51684v10.82428A7.52532,7.52532,0,0,1,969.428,620.18394Z",
    transform: "translate(-21.34638 -200.48312)",
    fill: "#3f3d56"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M980.5,570.76772c9,60-110.851,24.527-110.851,24.527l-43,72-22-7s15.32114-48.28121,33-90c7.851-18.527,97-14,97-14l1.851-14.527,51-1Z",
    transform: "translate(-21.34638 -200.48312)",
    fill: "#2f2e41"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M865.86593,582.42252l4.783,84.8722-21,3s-11.1914-42.11438-16.424-87.12128",
    transform: "translate(-21.34638 -200.48312)",
    fill: "#2f2e41"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M954.84794,441.16567l9.03812-11.61772,12.89267-.559,1.28679,10.92664,6.38828,2.94576a171.329,171.329,0,0,1,2.88591,74.22664l0,0v0a6.60919,6.60919,0,0,0-1.88,6.42l.41415,1.65108-.03832.06047a9.67173,9.67173,0,0,0-1.284,7.22047h0l11.67866,20.75192c-24.80059,10.10806-42.98157-8.74208-59.82466-33.44548l-10.424-36.083Z",
    transform: "translate(-21.34638 -200.48312)",
    fill: "#6c63ff"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "906.33 307.484 903.896 283.141 936.211 235.304 937.54 236.201 905.549 283.558 907.926 307.325 906.33 307.484",
    fill: "#2f2e41"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 907.12797,
    cy: 307.40458,
    r: 2.40553,
    fill: "#2f2e41"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 943.89412,
    cy: 208.43483,
    r: 23.83777,
    fill: "#ffb8b8"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M968.83776,379.90643l2.89212.76981.9822.26143,11.00626,2.92959c9.75542,2.59665,15.29559,13.59859,12.37434,24.57354,5.39381,9.35076.71988,18.02256-7.77417,26.4367a119.65544,119.65544,0,0,0-32.82019.03946l.18981-6.30089-4.81881,7.082q-4.12623.798-8.27853,1.94356c6.2918-12.39069,10.93041-25.18875,11.72056-35.87915l-5.04-1.34153,1.46811-5.51557-3.179,5.06017-9.1372-2.43209,0,0A24.857,24.857,0,0,1,968.83776,379.90643Z",
    transform: "translate(-21.34638 -200.48312)",
    fill: "#2f2e41"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 967.80692,
    cy: 182.93122,
    r: 11.22582,
    fill: "#2f2e41"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M949.459,566.33719a8.03788,8.03788,0,0,1,1.43533.13537l7.87765-49.87011-7.892-48.00969a12.09184,12.09184,0,0,1,23.47313-5.56813v0a95.39625,95.39625,0,0,1,4.33928,29.25562l-.27525,32.74152L957.416,575.30606a8.01612,8.01612,0,1,1-7.957-8.96887Z",
    transform: "translate(-21.34638 -200.48312)",
    fill: "#ffb8b8"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M978.69576,513.06693l-21.46542,1.06657-12.36088-43.60235a19.01659,19.01659,0,1,1,38.03318,0Z",
    transform: "translate(-21.34638 -200.48312)",
    fill: "#2f2e41"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M825.83014,697.76772h-7.70532l-1.37534-7.27479-3.52256,7.27479H792.79044a4.59391,4.59391,0,0,1-2.61038-8.37433L806.5,678.12229v-7.35457l17.1657,1.02454Z",
    transform: "translate(-21.34638 -200.48312)",
    fill: "#2f2e41"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M876.39927,694.88359l-7.64229.98344-2.2926-7.03975-2.56525,7.66488-20.26935,2.60834a4.5939,4.5939,0,0,1-3.65785-7.97266L854.71984,677.866l-.93867-7.29442,17.15607-1.17473Z",
    transform: "translate(-21.34638 -200.48312)",
    fill: "#2f2e41"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M665.98831,698.33006a1.19066,1.19066,0,0,1,1.18683-1.19452h510.294a1.19069,1.19069,0,0,1,0,2.38134h-510.294A1.19064,1.19064,0,0,1,665.98831,698.33006Z",
    transform: "translate(-21.34638 -200.48312)",
    fill: "#cacaca"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M941.61068,415.64038l-11.90772-.89259a3.84822,3.84822,0,0,1-3.54587-4.12l1.1368-15.1701a3.84766,3.84766,0,0,1,4.1207-3.54622l11.90773.89259.00052,0a3.84332,3.84332,0,0,1,3.54517,4.11994c1.77887,4.32945,8.44489,7.01171-1.13661,15.17005a3.84281,3.84281,0,0,1-4.12072,3.54625Z",
    transform: "translate(-21.34638 -200.48312)",
    fill: "#3f3d56"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M930.81334,391.73186l2.69217.26684-1.95443,23.39545-2.69259-.26676a3.84521,3.84521,0,0,1-2.61528-1.41823,4.02169,4.02169,0,0,1-.89092-2.888l1.29816-15.54156a3.86452,3.86452,0,0,1,3.01851-3.48562A3.73954,3.73954,0,0,1,930.81334,391.73186Z",
    transform: "translate(-21.34638 -200.48312)",
    fill: "#6c63ff"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M994.08167,412.19068l-53.76478-4.029a2.48835,2.48835,0,0,1-2.29291-2.66429l.30072-4.01353.0001-.00105a2.48551,2.48551,0,0,1,2.66469-2.29238l53.76459,4.0291h.00018a2.48554,2.48554,0,0,1,2.29292,2.66424l-.30083,4.014a2.48508,2.48508,0,0,1-2.66468,2.293Z",
    transform: "translate(-21.34638 -200.48312)",
    fill: "#3f3d56"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M933.189,401.40885l-.00039.00009a2.04792,2.04792,0,0,1-1.833-2.23692l.3229-3.255.00257-.026a2.04469,2.04469,0,0,1,4.06679.42929l-.3229,3.255a2.04395,2.04395,0,0,1-2.236,1.83356Z",
    transform: "translate(-21.34638 -200.48312)",
    fill: "#3f3d56"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M932.793,409.94159l-.00037,0a2.04469,2.04469,0,0,1-1.93563-2.14822l.17017-3.26715a2.04474,2.04474,0,0,1,4.08394.21271l-.17018,3.26715a2.04108,2.04108,0,0,1-2.14793,1.93552Z",
    transform: "translate(-21.34638 -200.48312)",
    fill: "#3f3d56"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M999.0296,539.58293l-3.06822-.03486a11.10662,11.10662,0,0,1-10.9674-11.21939l.02521-27.258a11.10664,11.10664,0,0,1,11.21939-10.9674l3.06818.03486a11.10658,11.10658,0,0,1,10.96737,11.2194l-.02518,27.25795A11.1066,11.1066,0,0,1,999.0296,539.58293Z",
    transform: "translate(-21.34638 -200.48312)",
    fill: "#3f3d56"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M942.33523,607.54227l2.30664-3.26757a33.004,33.004,0,0,0,18.99958,6.02c18.22744.00207,38.00543-56.29953,38.0075-74.527h4c-.0231,20.425-21.575,78.50392-42,78.527A36.76265,36.76265,0,0,1,942.33523,607.54227Z",
    transform: "translate(-21.34638 -200.48312)",
    fill: "#3f3d56"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M301.77809,574.2804a10.05577,10.05577,0,0,0-14.1374-6.15556l-25.56-24.97324-3.52158,18.23273,24.81214,20.91978a10.11027,10.11027,0,0,0,18.40683-8.02368Z",
    transform: "translate(-21.34638 -200.48312)",
    fill: "#ffb6b6"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M273.20131,575.615l-50.45456-40.46382.0307-.27382c.0584-.5237,5.89606-52.52779,8.89765-63.32863a29.68069,29.68069,0,0,1,11.14628-16.2935l.14069-.09089.16736.01226a15.062,15.062,0,0,1,13.7446,12.88281,106.6879,106.6879,0,0,1-4.62239,48.72226l-3.02253,8.90608,32.3253,34.49417Z",
    transform: "translate(-21.34638 -200.48312)",
    fill: "#6c63ff"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M184.45549,538.27118,184.02892,508.04a11.1066,11.1066,0,0,1,10.79184-11.38835l3.06728-.08249a11.10662,11.10662,0,0,1,11.38833,10.79186l.4266,30.23117a11.10661,11.10661,0,0,1-10.79187,11.38833l-3.06731.08251A11.10661,11.10661,0,0,1,184.45549,538.27118Z",
    transform: "translate(-21.34638 -200.48312)",
    fill: "#3f3d56"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M233.35105,610.76772c-20.425-.02307-42.9769-47.575-43-68h4c.00207,18.22747,20.78006,64.00207,39.0075,64a33.004,33.004,0,0,0,18.99958-6.02l2.30664,3.26758A36.76271,36.76271,0,0,1,233.35105,610.76772Z",
    transform: "translate(-21.34638 -200.48312)",
    fill: "#3f3d56"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M277.69067,420.45854a3.99827,3.99827,0,0,1-3.02542-3.64914c-9.789-8.65049-2.81912-11.30722-.89017-15.76686a3.9897,3.9897,0,0,1,3.7582-4.20846l.00054,0,12.37618-.69917a3.9942,3.9942,0,0,1,4.20924,3.7593l.89038,15.7669a3.9948,3.9948,0,0,1-3.75893,4.20848l-12.37618.69917A3.98028,3.98028,0,0,1,277.69067,420.45854Z",
    transform: "translate(-21.34638 -200.48312)",
    fill: "#3f3d56"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M291.72405,396.04617a4.01171,4.01171,0,0,1,3.06643,3.67537l1.05075,16.15552a4.17487,4.17487,0,0,1-.9798,2.98053,3.99172,3.99172,0,0,1-2.7415,1.42208l-2.79976.22548-1.582-24.31967,2.79932-.22559A3.88178,3.88178,0,0,1,291.72405,396.04617Z",
    transform: "translate(-21.34638 -200.48312)",
    fill: "#6c63ff"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M223.71428,415.91548a2.58418,2.58418,0,0,1-1.95605-2.35942l-.23563-4.17188a2.58021,2.58021,0,0,1,2.43069-2.72148h.00019L279.8332,403.507a2.58017,2.58017,0,0,1,2.722,2.43014l.00008.00109.23552,4.17142a2.58312,2.58312,0,0,1-2.43068,2.72154l-55.87992,3.15569A2.56642,2.56642,0,0,1,223.71428,415.91548Z",
    transform: "translate(-21.34638 -200.48312)",
    fill: "#3f3d56"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M287.20747,405.90336a2.1261,2.1261,0,0,1-1.60618-1.89071l-.273-3.38453a2.12256,2.12256,0,1,1,4.22915-.368l.00217.027.273,3.38454a2.12592,2.12592,0,0,1-1.94516,2.28674l-.0004-.0001A2.11576,2.11576,0,0,1,287.20747,405.90336Z",
    transform: "translate(-21.34638 -200.48312)",
    fill: "#3f3d56"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M287.54949,414.76093a2.12534,2.12534,0,0,1-1.60664-1.98863l-.11427-3.39426a2.12261,2.12261,0,0,1,4.24282-.14284l.11427,3.39426a2.12255,2.12255,0,0,1-2.05,2.19271l-.00037,0A2.13254,2.13254,0,0,1,287.54949,414.76093Z",
    transform: "translate(-21.34638 -200.48312)",
    fill: "#3f3d56"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "f2de2510-d869-4726-96f2-631808817dc6-533",
    "data-name": "af4baad4-c88d-44ba-bf25-f9ac1002d243",
    d: "M448.10849,243.55683l287.178-41.917v274.979l-287.178-41.916Z",
    transform: "translate(-21.34638 -200.48312)",
    fill: "#f2f2f2",
    opacity: 0.54
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M736.287,477.77464l-289.17871-42.207V242.69212l289.17871-42.209ZM449.10825,433.83811,734.287,475.4621V202.79661l-285.17871,41.625Z",
    transform: "translate(-21.34638 -200.48312)",
    fill: "#3f3d56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVirtualchat);
export default __webpack_public_path__ + "static/media/virtual chat.cd92fe900e84fdd7b7ac0794b605c5f6.svg";
export { ForwardRef as ReactComponent };